import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDialog,{staticClass:"d-inline",attrs:{"max-width":"480","value":""}},[_c(VCard,{staticClass:"text-xs-center"},[_c('title-bar',{attrs:{"dark":""}},[_vm._v(_vm._s(_vm.title))]),_c(VProgressCircular,{staticClass:"mt-3",attrs:{"indeterminate":!_vm.value,"rotate":360,"size":100,"width":15,"value":_vm.value,"color":"primary"}}),_c(VCardText,[_vm._v(_vm._s(_vm.text))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }